import { cleanUrl, displayHost } from '../utils/url';

/** One /rag passage, per the documented `snippet` schema (docs-api-data.ts).
 *  `snippet`, `url` and `published_at` are always there; every other field
 *  only when its include_* toggle was on, otherwise null here. */
export class Snippet {
  snippet!: string;
  url!: string;
  publishedAt: string | null = null;
  /** 0–1, four decimals. include_relevance_score */
  relevanceScore: number | null = null;
  /** include_original_language_snippet */
  originalLanguageSnippet: string | null = null;
  /** include_article_title */
  articleTitle: string | null = null;
  /** include_image_url */
  imageUrl: string | null = null;
  /** include_domain_name */
  domainName: string | null = null;
  /** include_favicon */
  favicon: string | null = null;

  constructor(data: any = {}) {
    this.snippet = data.snippet ?? '';
    this.url = cleanUrl(data.url) ?? '';
    this.publishedAt = data.published_at ?? null;
    this.relevanceScore = typeof data.relevance_score === 'number' ? data.relevance_score : null;
    this.originalLanguageSnippet = data.original_language_snippet ?? null;
    this.articleTitle = data.article_title ?? null;
    this.imageUrl = cleanUrl(data.image_url);
    this.domainName = data.domain_name ?? null;
    this.favicon = cleanUrl(data.favicon);
  }

  /** The domain to show, without "www.". */
  get host(): string {
    return displayHost(this.domainName, this.url);
  }
}
